import React from "react";
import { Segmented } from "antd";

const MySegmented = ({ options, value, setValue, className }) => {
  return <Segmented options={options} value={value} onChange={setValue} className={className} />
};

export default MySegmented;
